<script setup>
defineProps({
  selected: {
    type: Boolean,
    default: false
  }
})
</script>
<template>
<svg width="22" height="36" viewBox="0 0 22 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.86 14.5238V6.8758L13.636 5.0998H18.468L20.244 6.8758V14.5238L18.468 16.2998H13.636L11.86 14.5238ZM17.604 14.6998L18.388 13.9318V7.4678L17.604 6.6998H14.5L13.716 7.4678V13.9318L14.5 14.6998H17.604Z" :fill="selected ? '#021B27' : '#00CAAA'"/>
<path d="M4.82799 7.0678L2.37999 8.3318V6.6198L5.14799 5.0998H6.68399V16.2998H4.82799V7.0678Z" :fill="selected ? '#021B27' : '#00CAAA'"/>
<path d="M1.85999 29.0736V21.4256L3.63599 19.6496H8.46799L10.244 21.4256V29.0736L8.46799 30.8496H3.63599L1.85999 29.0736ZM7.60399 29.2496L8.38799 28.4816V22.0176L7.60399 21.2496H4.49999L3.71599 22.0176V28.4816L4.49999 29.2496H7.60399Z" :fill="selected ? '#021B27' : '#00CAAA'"/>
<path d="M15.828 21.6176L13.38 22.8816V21.1696L16.148 19.6496H17.684V30.8496H15.828V21.6176Z" :fill="selected ? '#021B27' : '#00CAAA'"/>
</svg>
</template>